<script lang="ts">
/*
Date Picker- should return/ fire event when date has been picked.
Originally default date picker element

should take a potential date as input to set, or just pick today

has to be int he format: "1964-04-20" / YYYY- MM - DD
*/
import { defineComponent, nextTick } from 'vue'
export default defineComponent({

async mounted()
{

        this.time_s = this.ChangeTimeToRequiredStringFormat(this.date_in);
        // console.log("Time Picker mounted, format is: ", this.time_s);

        // (this.$refs.time_input as any).value = this.time_s;
        // (this.$refs.time_input as any).valueAsDate = this.date_in;
        //           console.log("changed value on time picker to: ", (this.$refs.time_input as any).value);
},
props:
{
    date_in:{type:Date, default:new Date()},
    onTimeChanged:{type:Function, default:(date:Date)=>{console.log("Time changed, default function ", date)}},
},
data() {
        return {
        // icon:{ type:String, default:"home"},

        time_s:"1963-04-20",
        date_selected:new Date()

        };
    },
    //computed- so we can pass variables into css without having to do javascript
    //from: https://stackoverflow.com/questions/42872002/in-vue-js-component-how-to-use-props-in-css
    computed: {

        GetTime()
        {
            return this.time_s;
        }
  },
  methods:
  {
    ChangeTimeToRequiredStringFormat(date:Date)
    {
        //month is 0 based, but day is not...
        return this.AddZeroToDate(date.getHours()) +":"+this.AddZeroToDate(date.getMinutes())+":"+this.AddZeroToDate(date.getSeconds());
    },
    AddZeroToDate(num:number)
    {
        let str:string=num.toString();
        if(num<10)
            str="0"+str
        return str;

    },
    TimeChanged()
    {
        let time_str = (this.$refs.time_input as HTMLInputElement).value;
        // alert("time changed, to value: "+ time_str);
        // console.log("Time changed: ", time_str);
        let hours = parseInt(time_str.substring(0,2));
        let mins = parseInt(time_str.substring(3,5));
        let seconds = parseInt(time_str.substring(6,8));
        // console.log("Time changed2: ", hours, mins, seconds);
        this.date_selected.setHours(hours);
        this.date_selected.setMinutes(mins);

        if(!isNaN(seconds)) //Ios has an issue- doesn't supply time in the supplied format/ hh:mins:secs - just gives military time instead - no seconds (HH:MM)
            this.date_selected.setSeconds(seconds);

        //also set the day/ month/ year from date in
        this.date_selected.setFullYear(this.date_in.getFullYear());
        this.date_selected.setMonth(this.date_in.getMonth());
        this.date_selected.setDate(this.date_in.getDate());
        // console.log("Time changed3: ", this.date_selected);
        // alert("time_str: "+time_str+", hrs, mins, secs: "+hours+", "+mins+", "+seconds+", date selected:"+ this.date_selected);
        this.onTimeChanged(this.date_selected);
    },
    /**
     * 
     * @param time_str Ios 
     */
    
    

  },
  watch : 
    {
        date_in:function(date_in) 
        {
            // console.log("watch date_in start called");
            this.time_s = this.ChangeTimeToRequiredStringFormat(date_in);                  
        }
    },
});
</script>

<template>
    <!-- <p>DateTime date in: {{date_in}}</p> --> <!-- so need to watch when the prop changes, and update the data value-->
    <input type="time"  step="1" @change="TimeChanged" ref="time_input" :value="time_s" required/><!-- required gets rid of clear button in bottom right -->
</template>

<style scoped>
input
{
    font-size:30px;
    font-family:'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
}
@media only screen and (max-device-width: 460px)
{
    input
    {
        font-size:22px;
    }
}


</style>